import React from "react";

function GlobalSummaryModal(props) {
    const { movimenti, tipoFiltro, dataCorrente, onClose } = props;

    // Raggruppiamo i movimenti per conto / metodo di pagamento
    const contiRiepilogo = {};

    movimenti.forEach(m => {
        // Nome del conto (es. "PayPal (Principale)" oppure "Contanti")
        const nomeConto = m.nome ? `${m.nome} ${m.conto ? `(${m.conto})` : ''}` : 'Conto non specificato';

        if (!contiRiepilogo[nomeConto]) {
            contiRiepilogo[nomeConto] = { entrate: 0, uscite: 0, movimenti: [] };
        }

        const importoNum = Number(m.importo);
        if (m.eu) {
            contiRiepilogo[nomeConto].entrate += importoNum;
        } else {
            contiRiepilogo[nomeConto].uscite += importoNum;
        }
        contiRiepilogo[nomeConto].movimenti.push(m);
    });

    // Calcoli globali totali
    const entrateTotali = movimenti.filter(m => m.eu).reduce((acc, m) => acc + Number(m.importo), 0);
    const usciteTotali = movimenti.filter(m => !m.eu).reduce((acc, m) => acc + Number(m.importo), 0);
    const bilancioComplessivo = entrateTotali - usciteTotali;

    const ottieniTitoloPeriodo = () => {
        if (tipoFiltro === 'giornaliero') {
            return `del giorno ${dataCorrente.toLocaleDateString('it-IT')}`;
        } else if (tipoFiltro === 'mensile') {
            return `del mese di ${dataCorrente.toLocaleString('it-IT', { month: 'long', year: 'numeric' })}`;
        } else {
            return `dell'anno ${dataCorrente.getFullYear()}`;
        }
    };

    return (
        <div style={styles.modalOverlay}>
            <div style={styles.modalContent}>
                <h2>Riepilogo per Conto</h2>
                <p style={styles.modalSubtitle}>{ottieniTitoloPeriodo()}</p>

                {/* Box Totale Generale */}
                <div style={styles.dailyTotalBox}>
                    <span style={styles.dailyTotalLabel}>Bilancio Complessivo:</span>
                    <span style={{ fontSize: '1.2rem', fontWeight: 'bold', color: bilancioComplessivo >= 0 ? '#22c55e' : '#ef4444' }}>
                        € {bilancioComplessivo.toFixed(2)}
                    </span>
                </div>

                {/* Lista dei conti con relative entrate e uscite */}
                <div style={styles.accountsList}>
                    {Object.keys(contiRiepilogo).length > 0 ? (
                        Object.entries(contiRiepilogo).map(([nomeConto, dati], index) => {
                            const saldoConto = dati.entrate - dati.uscite;
                            return (
                                <div key={index} style={styles.accountCard}>
                                    <div style={styles.accountHeader}>
                                        <strong>{nomeConto}</strong>
                                        <span style={{ color: saldoConto >= 0 ? '#22c55e' : '#ef4444', fontWeight: 'bold' }}>
                                            € {saldoConto.toFixed(2)}
                                        </span>
                                    </div>
                                    <div style={styles.accountDetails}>
                                        <span style={{ color: '#22c55e' }}>Entrate: +€ {dati.entrate.toFixed(2)}</span>
                                        <span style={{ color: '#ef4444' }}>Uscite: -€ {dati.uscite.toFixed(2)}</span>
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <p style={{ color: '#94a3b8', textAlign: 'center', margin: '20px 0' }}>Nessun movimento registrato in questo periodo.</p>
                    )}
                </div>

                {/* Tasto Chiudi coerente con lo stile */}
                <div style={styles.modalButtons}>
                    <button onClick={onClose} style={styles.cancelBtn}>Chiudi</button>
                </div>
            </div>
        </div>
    );
}

const styles = {
    modalOverlay: {
        position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.75)', backdropFilter: 'blur(4px)',
        display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000,
    },
    modalContent: {
        backgroundColor: '#1e293b', padding: '28px', borderRadius: '16px',
        width: '100%', maxWidth: '450px', color: '#ffffff', border: '1px solid #334155',
        boxShadow: '0 25px 30px -10px rgba(0,0,0,0.6)', textAlign: 'center',
    },
    modalSubtitle: {
        color: '#94a3b8', fontSize: '0.9rem', marginTop: '-4px', marginBottom: '15px', textTransform: 'capitalize'
    },
    dailyTotalBox: {
        backgroundColor: '#0f172a', border: '1px solid #334155', padding: '12px 18px',
        borderRadius: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px'
    },
    dailyTotalLabel: { color: '#cbd5e1', fontSize: '1rem', fontWeight: 'bold' },
    accountsList: {
        display: 'flex', flexDirection: 'column', gap: '10px', maxHeight: '280px', overflowY: 'auto', paddingRight: '4px', marginBottom: '15px'
    },
    accountCard: {
        backgroundColor: '#0f172a', border: '1px solid #334155', borderRadius: '10px', padding: '12px 15px', textAlign: 'left'
    },
    accountHeader: {
        display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px', fontSize: '1rem'
    },
    accountDetails: {
        display: 'flex', justifyContent: 'space-between', fontSize: '0.85rem'
    },
    modalButtons: {
        display: 'flex', marginTop: '10px'
    },
    cancelBtn: {
        flex: 1, backgroundColor: 'transparent', color: '#cbd5e1', border: '1px solid #475569',
        padding: '11px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', transition: 'background 0.2s'
    }
};

export default GlobalSummaryModal;
